/* eslint-disable jsx-a11y/anchor-is-valid */
import LOGO from "../assets/images/logo.png"
import React, { Component } from "react"
import { Modal } from "react-bootstrap"
import {
  locale,
  tokens,
  select_style,
  required,
  // alert
  success,
  success_url,
  alert,
  alert_url,
  // function
  logout,
  number_zero,
  format_date,
  toFixed,
  total,
  validate,
  random_charactor,
  float,
  // api
  GET,
  POST,
  PUT,
  DELETE,
  error_message,
  // storage
  removeStorage,
  getStorage,

  validate_email,
  validate_th,
  validate_en,
  validate_en_number,

  LinktoBase64,
  // component
  DatePicker,
} from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";
export default class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "",
      password: "",
      remember: false,
      loading: false,
    }
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    if (token) {
      window.location.href = "/console";
    } else {
      removeStorage();
    }
  }
  Login = async () => {
    if (this.state.username.trim() === "") {
      alert("warning", "แจ้งเตือน", "กรุณากรอกอีเมล/ชื่อผู้ใช้")
      return
    } else if (this.state.password.trim() === "") {
      alert("warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่าน")
      return
    }
    this.setState({ loading: true });
    let data = {
      username: this.state.username,
      password: this.state.password,
      remember: this.state.remember,
    }
    let result = await POST("", "v1/TH/login", data);
    if (result && result.status) {
      console.log(result)
      let user = {
        user_id: result.data.user_id,
        user_code: result.data.user_code,
        user_type: result.data.user_type,
        username: result.data.username,
        full_name: result.data.full_name,
        email: result.data.email,
        phone: result.data.phone,
        is_active: result.data.is_active,
        picture: result.data.picture,
        branch_id: result.data.branch_id,
        branch_name: result.data.branch_name,
      }

      localStorage.setItem("token", "token " + result.token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("permission", JSON.stringify(result.data.role_data.permission));
      if (result.data.branch_id) {
        let branch = {
          branch_id: result.data.branch_id,
          branch_name: result.data.branch_name,
        }
        localStorage.setItem("branch", JSON.stringify(branch))
        window.location.href = "/dashboard"
      } else {
        window.location.href = "/console";
      }
    }
    this.setState({ loading: false });
  }
  render() {
    return (
      <div className="w-100">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="row background pt-5" style={{ height: "100vh" }}>
          <div className="col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4 col-xxl-3 mx-auto my-auto">
            {/* <div className="d-flex justify-content-center mb-2">
              <img src={LOGO} style={{ width: 170 }} />
            </div> */}
            <div className="card shadow  blur" style={{ borderRadius: 32, background: "#ffffff70", border: "solid red" }}>
            <div className="w-100 p-4">
              <h3><b>ลงชื่อเข้าใช้</b></h3>
                <input
                  className="form-control border-0 mb-4 bg-contain"
                  type="text"
                  placeholder="Username/email"
                  onChange={(e) => this.setState({ username: e.target.value })}
                />
                <input
                  className="form-control border-0 mb-4 bg-contain"
                  type="password"
                  placeholder="รหัสผ่าน"
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Login()
                    } else {
                      this.setState({ password: e.target.value })
                    }
                  }}
                />
                <div style={{display: "flex" }}>
                  <input 
                    type="checkbox" 
                    id="rememberMe"
                    className="checkbox mb-4"
                    style={{marginRight : "8px", alignItems: "baseline", marginTop: "3px"}}
                    checked={this.state.remember} 
                    onChange={(e) => this.setState({ remember: e.target.checked })}
                  />
                  <label className="form-check-label user-profile " style={{alignItems: "baseline"}} htmlFor="rememberMe">
                    Remember Me
                  </label>
                </div>
                <button 
                  type="button" 
                  className="btn btn-orange w-100 mb-2" 
                  onClick={() => this.Login()}
                >
                  เข้าสู่ระบบ
                </button>
                <div className="w-100 text-center mt-2">
                  <small className="text-secondary">{global.version}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
